import { useMemo } from "react";
import moment from "moment";

const categoryOptions = [
  { label: "เครื่องประดับ", id: 1 },
  { label: "อิเล็กทรอนิกส์", id: 2 },
  { label: "ทองคำ", id: 3 },
  { label: "พระเครื่อง", id: 4 },
  { label: "แบรนด์เนม", id: 5 },
  { label: "นาฬิกา", id: 6 },
];
const useProductData = (fetchData) => {
  const data = fetchData;
  
    const formattedData = useMemo(() => {
      const rows = [];
  
      if (data && Array.isArray(data)) {
        data.forEach((orderWrapper, index) => {
          const order = orderWrapper.Order || {};
          const customer = order.Customer || {};
          const company = order.Company || {};

          console.log({customer});
  
          // Consolidate all related order items into one list
          const allOrderItems = [
            ...(order.order_borrows || []),
            ...(order.Order_sells || []),
            ...(order.Order_items || []),
            ...(order.order_pawns || []),
          ];
          const formattedItems = allOrderItems.map((item) => {
            const product = item.Product || {};
            return {
              id: item.id || "",
              lenting_amount: item.lenting_amount || item.selling_amount || 0,
              total_amount: item.total_amount || product.total_amount || 0,
              product_price: item.price || product.price || 0,
              total_price: item.total_price || product.total_price || 0,
              status: item.status || "",
              return_date: item.return_date
                ? moment(item.return_date).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
                : "",
              product_id: product.product_id || item.product_id || "",
              product_name: product.product_name || "",
              product_code: product.product_code || "",
              category_id: product.category_id || "",
              category: categoryOptions.find(
                (category) => category.id === product.category_id
              )?.label,
              price: product.price || "",
              sell_price: product.sell_price || 0,
              detail: product.detail || "",
              blemishes: product.blemishes || "",
              notes: product.notes || "",
              size: product.size || "",
              product_code_com: product.product_code_com || "",
              product_type: product.product_type || "",
              order_status: item.order_status || "",
              pictures: Array.isArray(product.Pictures)
                ? product.Pictures.map((picture) => ({
                    id: picture.id,
                    picture: picture.pic
                      .split("http")
                      .filter(Boolean)
                      .map((url) => `http${url.trim()}`),
                  }))
                : [], // Ensure pictures is always an array
            };
          });
  
          // Calculate totals and other aggregated fields
          const total_price = formattedItems.reduce(
            (sum, item) => sum + parseFloat(item.total_price || 0),
            0
          );
          const lenting_amount = formattedItems.reduce(
            (sum, item) => sum + parseFloat(item.lenting_amount || 0),
            0
          );
          const return_date =
            formattedItems.length > 0
              ? moment(formattedItems[0].return_date).format(
                  "DD/MM/YYYY\n เวลา HH:mm:ss น."
                )
              : "";
  
          const length_type = formattedItems.length;

          // Create a single row for the order
          const row = {
            ...(formattedItems.length > 0 && formattedItems[0]),
            id: order.id || index,
            order_code: order.order_code || "",
            qrcode: order.qrcode || "",
            company_id: company.company_id || "",
            company_name: company.company_name || "",
            order_status: orderWrapper.status_id || "",
            created_date: orderWrapper.created_date
              ? moment(orderWrapper.created_date).format(
                  "DD/MM/YYYY\n เวลา HH:mm:ss น."
                )
              : "",
            updated_date: order.updated_at
              ? moment(order.updated_at).format("DD/MM/YYYY\n เวลา HH:mm:ss น.")
              : "",
            customer_name: customer.name || "",
            idcard: customer.idcard || "",
            customer_phonenumber: customer.phonenumber || "",
            customer_address: customer.address || "",
            picture:
              formattedItems.length > 0 && formattedItems[0].pictures.length > 0
                ? formattedItems[0].pictures
                : [], // กรณีที่ไม่มีข้อมูล
            // order_items: formattedItems, // Include all formatted items
            total_price: total_price,
            lenting_amount: lenting_amount,
            return_date: return_date,
            length_type: length_type,
            product_type: formattedItems[0]?.product_type || "",
          };
  
          rows.push(row);
        });
        // console.log("Formatted Rows:", rows);
      }
  
      return rows;
    }, [data]);
  
    return formattedData;
};

export default useProductData;
